<template>
  <div   v-if="visible"   class="toast" :class="type">
    <i class="toast-icon"></i>
    <p>{{ message }}</p>
  </div>
</template>

<script>
export default {
  props: {
    message: String,
    visible: Boolean,
    type: {
      type: String,
      default: 'success' // 支持 'success', 'error', 'warning', 'info'
    }
  },
  data() {
    return {
      timer: null
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        // 3秒后自动消失
        this.timer = setTimeout(() => {
          this.$emit('update:visible', false);
        }, 3000);
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer); // 清除定时器
  }
};
</script>
<style scoped>
.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  font-size: 16px;
  color: #fff;
  background-color: #f0f9eb; /* 默认背景 */
  transition: opacity 0.3s ease-in-out;
  z-index: 9999;
}

/* 根据类型改变样式 */
.toast.success {
  background-color: #f0f9eb;
  color: #67c23a;
}
.toast.error {
  background-color: #fef0f0;
  color: #f56c6c;
}
.toast.warning {
  background-color: #fdf6ec;
  color: #e6a23c;
}
.toast.info {
  background-color: #f4f4f5;
  color: #909399;
}

/* 图标样式 */
.toast-icon {
  margin-right: 12px;
  font-size: 20px;
  line-height: 1;
}

/* 对应类型的图标 */
.toast.success .toast-icon {
  content: '✔'; /* 替换为适合的图标或使用图标库 */
  color: #67c23a;
}
.toast.error .toast-icon {
  content: '✖';
  color: #f56c6c;
}
.toast.warning .toast-icon {
  content: '⚠';
  color: #e6a23c;
}
.toast.info .toast-icon {
  content: 'ℹ';
  color: #909399;
}
</style>





// WEBPACK FOOTER //
// src/components/Toast.vue